/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypemultiplechoice3Inputs */

const zh_learn_mistakestypemultiplechoice3 = /** @type {(inputs: Learn_Mistakestypemultiplechoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择题`)
};

const en_learn_mistakestypemultiplechoice3 = /** @type {(inputs: Learn_Mistakestypemultiplechoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple Choice`)
};

const es_learn_mistakestypemultiplechoice3 = /** @type {(inputs: Learn_Mistakestypemultiplechoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opción múltiple`)
};

/**
* | output |
* | --- |
* | "Multiple Choice" |
*
* @param {Learn_Mistakestypemultiplechoice3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypemultiplechoice3 = /** @type {((inputs?: Learn_Mistakestypemultiplechoice3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypemultiplechoice3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypemultiplechoice3(inputs)
	if (locale === "en") return en_learn_mistakestypemultiplechoice3(inputs)
	return es_learn_mistakestypemultiplechoice3(inputs)
});
export { learn_mistakestypemultiplechoice3 as "learn_mistakesTypeMultipleChoice" }